export { default as moduleQuerySplitter } from './moduleQuerySplitter';
